import ProfileContainer from './ProfileContainer';

export default ProfileContainer;



// WEBPACK FOOTER //
// ./src/components/pages/User/Profile/index.js